(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('UserService', UserService);

    UserService.$inject = ['$http', '$q', 'RequestService', 'ModalConstructor', 'AlertModalService'];

    function UserService($http, $q, RequestService, ModalConstructor, AlertModalService) {

        return {
            // Api Methods
            getUserList: getUserList,
            getUser: getUser,
            getCurrentUser: getCurrentUser,
            getLoggedUsers: getLoggedUsers,
            addUser: addUser,
            updateUser: updateUser,
            deleteUser: deleteUser,
            changePassword: changePassword,
            recoverPassword: recoverPassword,
            // Group Methods
            getGroups: getGroups,
            // Modal Methods
            addUserModalConstructor: addUserModalConstructor,
            editUserModalConstructor: editUserModalConstructor,
            changePasswordModalConstructor: changePasswordModalConstructor,
            deleteUserModalConstructor: deleteUserModalConstructor,
            confirmationOltModalConstructor: confirmationOltModalConstructor,
            errorModalConstructor: errorModalConstructor,
            successModalConstructor: successModalConstructor
        };

        // Api Methods
        function getUserList() {
            return $http.get(userApi()).then(responseData);
        }

        function getUser(userId) {
            return $http.get(userApi(userId)).then(responseData);
        }

        function getCurrentUser() {
            return $http
                    .get(userApi('current'), {ignoreCancel: true})
                    .then(responseData);
        }

        function getLoggedUsers() {
            return $http.get(userApi('loggedusers')).then(responseData);
        }

        function addUser(data) {
            return $http.post(userApi(), data).then(responseData);
        }

        function updateUser(data) {
            return $http.put(userApi(), data).then(responseData);
        }

        function deleteUser(userId) {
            return $http.delete(userApi(userId)).then(responseData);
        }

        function changePassword(data) {
            return $http.put(userApi('changepassword'), data).then(responseData);
        }

        function recoverPassword(data) {
            return $http.post(userApi('recoverpassword'), data).then(responseData);
        }

        // Group Methods
        function getGroups() {
            return $http.get(groupApi()).then(responseData);
        }

        // Modal Methods
        function addUserModalConstructor(scope) {
            var modal = userModalConfig(scope);
            ModalConstructor.open(modal);
        }

        function editUserModalConstructor(userId, scope) {
            var modal = userModalConfig(scope);
            modal.resolve.userId = userId;
            ModalConstructor.open(modal);
        }

        function changePasswordModalConstructor(userId, scope) {
            var changePassword = {
                templateUrl: 'app/components/user/user-change-password.html',
                controller: 'UserChangePasswordController',
                controllerAs: 'vmUserChangePassword',
                size: 'sm',
                backdrop: 'static',
                resolve: {userId: userId},
                scope: scope
            };
            return ModalConstructor.open(changePassword);
        }

        function deleteUserModalConstructor(userData, scope) {
            var confirmOlt = {
                templateUrl: 'app/components/user/user-delete.html',
                controller: 'UserDeleteController',
                controllerAs: 'vmUserDelete',
                size: 'sm',
                backdrop: 'static',
                resolve: {userData: userData},
                scope: scope
            };
            ModalConstructor.open(confirmOlt);
        }

        function confirmationOltModalConstructor(oltsData, dataAction) {
            var confirm = {
                templateUrl: 'app/components/user/user-confirm.html',
                controller: 'UserConfirmController',
                controllerAs: 'vmUserConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction;
                    },
                    oltList: function () {
                        return oltsData;
                    }
                }
            };
            ModalConstructor.open(confirm);
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'user');
        }

        function successModalConstructor(action, isMultiple) {
            AlertModalService.success(action, isMultiple, 'user');
        }

        // Helper functions
        function userApi(method) {
            return RequestService.apiUrl('users', method);
        }

        function groupApi(method) {
            return RequestService.apiUrl('groups', method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        function userModalConfig(scope) {
            return {
                templateUrl: 'app/components/user/user-add.html',
                controller: 'UserAddController',
                controllerAs: 'vmUserAdd',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    userId: null,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('user-modals');
                            $translatePartialLoader.addPart('user');
                            return $translate.refresh();
                        }]
                },
                scope: scope
            };
        }

    }

})();
